import { SVGProps, useId } from "react";

export const CalculatorIcon = (props: SVGProps<SVGSVGElement>) => {
  const gradientIdA = useId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={15}
      height={15}
      viewBox="0 0 17 17"
      fill="none"
      {...props}
    >
      <path
        fill={`url(#${gradientIdA})`}
        d="M4.039 10.961v1.46a.402.402 0 0 0 .414.415.402.402 0 0 0 .414-.414v-1.46h1.461a.402.402 0 0 0 .414-.415.402.402 0 0 0-.414-.415h-1.46v-1.46a.402.402 0 0 0-.415-.415.402.402 0 0 0-.414.415v1.46h-1.46a.402.402 0 0 0-.415.415.402.402 0 0 0 .414.414h1.46Zm5.102 1.172h3.28a.401.401 0 0 0 .415-.414.402.402 0 0 0-.414-.415H9.14a.402.402 0 0 0-.415.415.402.402 0 0 0 .415.414Zm0-2.344h3.28a.402.402 0 0 0 .415-.414.402.402 0 0 0-.414-.414H9.14a.402.402 0 0 0-.415.414.402.402 0 0 0 .415.414Zm1.64-5.019 1.02 1.02c.08.08.174.123.283.128.11.007.21-.036.303-.129a.415.415 0 0 0 .137-.29.412.412 0 0 0-.131-.298l-1.024-1.03 1.018-1.018a.417.417 0 0 0 .13-.284.387.387 0 0 0-.13-.303.412.412 0 0 0-.293-.14.412.412 0 0 0-.294.14l-1.019 1.018-1.019-1.018a.417.417 0 0 0-.284-.13.387.387 0 0 0-.303.13.412.412 0 0 0-.14.293c0 .103.047.201.14.294l1.018 1.019-1.023 1.03a.437.437 0 0 0-.125.284c-.006.11.037.21.13.303s.19.139.294.139c.103 0 .2-.046.293-.139l1.02-1.019Zm-7.969-.184h3.282a.402.402 0 0 0 .414-.414.402.402 0 0 0-.414-.414H2.812a.402.402 0 0 0-.414.414.402.402 0 0 0 .414.414ZM1.514 15c-.431 0-.791-.144-1.08-.433-.29-.29-.434-.65-.434-1.081V1.514C0 1.083.145.723.434.434.723.144 1.083 0 1.514 0h11.972c.431 0 .791.145 1.08.434.29.289.434.649.434 1.08v11.972c0 .431-.144.791-.433 1.08-.29.29-.65.434-1.081.434H1.514Zm0-.938h11.972c.144 0 .276-.06.396-.18s.18-.252.18-.396V1.514a.553.553 0 0 0-.18-.397.553.553 0 0 0-.396-.18H1.514a.553.553 0 0 0-.397.18.553.553 0 0 0-.18.397v11.972c0 .144.06.276.18.396.121.12.253.18.397.18Z"
      />
      <defs>
        <linearGradient
          id={gradientIdA}
          x1={0}
          x2={7.898}
          y1={7.38}
          y2={7.779}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="var(--start-color, #000)" />
          <stop offset={1} stopColor="var(--end-color, #000)" />
        </linearGradient>
      </defs>
    </svg>
  );
};
